import React from 'react';
import { Form, Input } from '@common/components';
type Props = {
  fieldName: string | (string | number)[];
  organizationUnits: { id: string; name: string }[];
  currentOrganizationUnitId?: string;
  getAllUnitNames?: () => string[];
};

export const FormFieldUnitName = ({
  fieldName,
  currentOrganizationUnitId,
  organizationUnits,
  getAllUnitNames,
}: Props) => (
  <Form.Item
    label="Unit Name"
    name={fieldName}
    rules={[
      {
        required: true,
        message: "Value can't be blank",
      },
      {
        message: 'Unit Name already exists for this Facility',
        validator: (_, value) => {
          const allOtherFacilityUnitsNames = organizationUnits
            .filter(
              (organizationUnit) =>
                organizationUnit.id !== currentOrganizationUnitId
            )
            .map((organizationUnit) => organizationUnit.name);

          if (allOtherFacilityUnitsNames?.includes(value)) {
            return Promise.reject(true);
          }
          return Promise.resolve();
        },
      },
      {
        message: 'Unit Name already exists in this form',
        validator: (_, value) => {
          const allOtherFormUnitsNames = getAllUnitNames?.() || [];
          const sameUnitNames = allOtherFormUnitsNames.filter(
            (unitName) => value === unitName
          );

          if (sameUnitNames.length > 1) {
            return Promise.reject(true);
          }
          return Promise.resolve();
        },
      },
    ]}
  >
    <Input placeholder="Type the Unit Name" />
  </Form.Item>
);
